import { React, ui } from "./common";

const ACKNOWLEDGED_KEY = "DashboardRedirect.acknowledged";

// The URL comes from Hosting:DashboardBaseUrl, but changing that restarts the web app. To turn the
// redirect off mid-day, set "disableDashboardRedirect": true in wwwroot/config.json instead.
// Anything going wrong here leaves the user on this dashboard.
async function getRedirectTarget(): Promise<URL | null> {
    try {
        // no-store because browsers would otherwise reuse a cached copy, and the off switch wouldn't reach them
        const config = await (await fetch("./config.json", { cache: "no-store" })).json();
        if (config.disableDashboardRedirect === true) return null;

        const response = await fetch(`${config.apiUrl || ""}/public/dashboard-url`, { headers: { Accept: "application/json" } });
        if (!response.ok) return null;

        const { dashboardUrl } = await response.json();
        const target = new URL(dashboardUrl);
        return target.host === window.location.host ? null : target;
    } catch (err) {
        console.log("Unable to check for the dashboard redirect", err);
        return null;
    }
}

function redirect(target: URL) {
    // Keep the hash so bookmarks and emailed links land on the same page. replace() so the back
    // button doesn't come straight back here and redirect again.
    target.hash = window.location.hash;
    window.location.replace(target.href);
}

export default function DashboardRedirect(props: { children: any }) {
    const [checked, setChecked] = React.useState(false);
    const [target, setTarget] = React.useState<URL | null>(null);

    React.useEffect(() => {
        getRedirectTarget().then(url => {
            if (url && localStorage.getItem(ACKNOWLEDGED_KEY)) {
                redirect(url);
            } else {
                setTarget(url);
                setChecked(true);
            }
        });
    }, []);

    function acknowledge() {
        localStorage.setItem(ACKNOWLEDGED_KEY, "true");
        redirect(target);
    }

    if (!checked) {
        return <div style={{ textAlign: "center", marginTop: 200 }}><ui.Spin size="large" /></div>;
    }

    if (target) {
        return (
            <ui.Modal open={true} closable={false} maskClosable={false} keyboard={false} title="Evo Voice has a new dashboard" footer={<ui.Button type="primary" onClick={acknowledge}>OK</ui.Button>}>
                <p>The Evo Voice dashboard has moved. Click OK to go to the new dashboard.</p>
                <p>You will need to sign in again the first time. Your existing bookmarks will keep working and take you there automatically.</p>
            </ui.Modal>
        );
    }

    return props.children;
}
